import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog, Button, Modal } from "@mui/material";
import styles from "./NewReportModal.module.css";
import reportGrowth from "../../../../../assets/images/report-growth.svg";
import reportLeadership from "../../../../../assets/images/report-leadership.svg";
import reportEvent from "../../../../../assets/images/report-event.svg";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import transaction from "../../../../../assets/images/transaction-report.svg";

interface NewReportModalProps {
  page: string;
}
const NewReportModal: React.FC<NewReportModalProps> = ({ page }) => {
  const navigate = useNavigate();
  const reportType = [
    {
      label: "leads",
      icon: reportLeadership,
    },
    {
      label: "attendance",
      icon: reportEvent,
    },
    {
      label: "transactions",
      icon: transaction,
    },
    {
      label: "revenue",
      icon: reportGrowth,
    },
  ];
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [selectedReport, setSelectedReport] = useState("");

  const handleNewReportClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleSelect = (type: string) => {
    setSelectedReport(type);
  };

  const handleSubmit = () => {
    if (selectedReport === "leads") {
      navigate("/app/Reports/LeadReportCreation", {
        state: {
          from:
            page === "RECENTREPORTS"
              ? "RecentReports"
              : page === "CREATEDBYME"
                ? "CreatedByMe"
                : "AllReports",
          isFromView: false,
        },
      });
    } else if (selectedReport === "revenue") {
      navigate("/app/Reports/CreateReport/Revenue", {
        state: {
          from:
            page === "RECENTREPORTS"
              ? "RecentReports"
              : page === "CREATEDBYME"
                ? "CreatedByMe"
                : "AllReports",
          isFromView: false,
        },
      });
    } else if (selectedReport === "transactions") {
      navigate("/app/Reports/CreateReport/Transaction", {
        state: {
          from:
            page === "RECENTREPORTS"
              ? "RecentReports"
              : page === "CREATEDBYME"
                ? "CreatedByMe"
                : "AllReports",
          isFromView: false,
        },
      });
    } else {
      navigate("/app/Reports/AttendanceReportCreation", {
        state: {
          from:
            page === "RECENTREPORTS"
              ? "RecentReports"
              : page === "CREATEDBYME"
                ? "CreatedByMe"
                : "AllReports",
          isFromView: false,
        },
      });
    }
    handleCloseModal();
    setSelectedReport("");
  };

  const instituteData = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        sx={{ background: "#11C89B", textTransform: "capitalize" }}
        onClick={handleNewReportClick}
        disabled={instituteData?.isMigrated === true ? true : false}
      >
        New Report
      </Button>
      {isModalOpen && (
        <Modal open={isModalOpen} onClose={handleCloseModal}>
          <Dialog
            open={isModalOpen}
            onClose={handleCloseModal}
            sx={{
              zIndex: "99999",
              "& .MuiDialog-paper": {
                maxHeight: "480px",
                minHeight: "165px",
                padding: "24px",
                borderRadius: "12px",
                boxShadow:
                  "0px 8px 8px -4px rgba(16, 24, 40, 0.03), 0px 20px 24px -4px rgba(16, 24, 40, 0.08)",
                left: "5%",
                top: "2%",
                background: "#FFFFFF",
                overflow: "hidden",
              },
            }}
          >
            <div>
              <div className={styles.modalTitleWrap}>
                <div className={styles.modalTitle}>Create New Report</div>
                <div className={styles.closeModalButton}>
                  <CloseIcon
                    sx={{ color: "#555555" }}
                    onClick={() => {
                      handleCloseModal();
                      setSelectedReport("");
                    }}
                  />
                </div>
              </div>

              <div className={styles.buttonContainer}>
                {reportType?.map((item: any, index: number) => (
                  <Button
                    key={`${item?.label}-${index}`}
                    variant="outlined"
                    onClick={() => handleSelect(item?.label)}
                    className={styles.reportButton}
                    style={{
                      backgroundColor:
                        selectedReport === item?.label
                          ? "#e8faf5"
                          : "transparent",
                      color: "black",
                    }}
                  >
                    <div className={styles.iconContainer}>
                      <img
                        src={item?.icon}
                        alt={item?.label}
                        className={styles.icon}
                      />
                      {item?.label}
                    </div>
                  </Button>
                ))}
              </div>
            </div>
            <div className={styles.buttonSection}>
              <Button
                variant="outlined"
                sx={{
                  color: "#BFBFBF",
                  fontWeight: "500",
                  lineHeight: "10px 24px 24px 24px",
                  textTransform: "capitalize",
                  borderRadius: "4px",
                  border: "1px solid #BFBFBF",
                  backgroundColor: "#FFF",
                  "&:hover": {
                    backgroundColor: "#FFF",
                    border: "1px solid #BFBFBF",
                  },
                }}
                onClick={() => {
                  handleCloseModal();
                  setSelectedReport("");
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ textTransform: "capitalize", marginLeft: "10px" }}
                onClick={() => {
                  handleSubmit();
                  localStorage.removeItem("from");
                  localStorage.removeItem("isFromView");
                }}
                disabled={selectedReport === ""}
              >
                Create
              </Button>
            </div>
          </Dialog>
        </Modal>
      )}
    </div>
  );
};
export default NewReportModal;
